// Location: frontend/src/admin/Component/Login.jsx
// Complete replace - Secure API-based login

import React, { useEffect, useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { useAuth } from '../../Utilities/ContextAPI/AuthProvider';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4100";

const Login = () => {
    const { user, loading, setUser } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && user) {
            navigate("/dashboard");
        }
    }, [user, loading, navigate]);

    const [LoginData, setLoginData] = useState({
        email: "",
        password: ""
    });
    const [rememberMe, setRememberMe] = useState(false);
    const [Error, setError] = useState({});
    const [passwordshow, setpasswordshow] = useState("password");
    const [submitting, setSubmitting] = useState(false);

    const emailregex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

    const handleChange = (e) => {
        setLoginData({ ...LoginData, [e.target.name]: e.target.value });
        // Clear error when user starts typing
        if (Error[e.target.name]) {
            setError({ ...Error, [e.target.name]: "" });
        }
    };

    const handlepasswordshowornot = () => {
        setpasswordshow(passwordshow === "password" ? "text" : "password");
    };

    const handleRememberMeChange = (e) => {
        setRememberMe(e.target.checked);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        setSubmitting(true);

        try {
            const apiPayload = {
                ...LoginData,
                rememberMe: rememberMe
            };

            const response = await axios.post(
                `${API_URL}/admin/login`,
                apiPayload,
                { withCredentials: true } // Important for cookies
            );

            if (response.data.success) {
                // Store user data in Storage based on Remember Me
                const userData = JSON.stringify(response.data.data);
                if (rememberMe) {
                    localStorage.setItem("InfinexAdminUser", userData);
                } else {
                    sessionStorage.setItem("InfinexAdminUser", userData);
                }

                // Update context immediately so AdminRoute allows access
                setUser(response.data.data);

                // Success message
                // alert(`Welcome ${response.data.data.name}!`); // Removed alert for smoother flow

                // Clear form
                setLoginData({
                    email: "",
                    password: ""
                });

                // Navigate to dashboard
                navigate("/dashboard");
            } else {
                alert(response.data.message || "Login failed");
            }
        } catch (error) {
            console.error("Login error:", error);
            if (error.response?.data?.message) {
                alert(error.response.data.message);
            } else {
                alert("Login failed. Please check your credentials and try again.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    const validate = () => {
        // ... (validation logic same as before)
        let localError = {};
        let valid = true;

        if (LoginData.email.length === 0) {
            localError.email = "Email is required!";
            valid = false;
        } else if (!emailregex.test(LoginData.email)) {
            localError.email = "Please enter a valid email";
            valid = false;
        }

        if (LoginData.password.length === 0) {
            localError.password = "Password required";
            valid = false;
        } else if (LoginData.password.length < 6) {
            localError.password = "Password must be at least 6 characters";
            valid = false;
        }

        setError(localError);
        return valid;
    };


    return (
        <div className="min-h-screen flex justify-center items-center bg-light-bg font-sans">
            <div className="bg-white p-8 rounded-admin shadow-lg container w-11/12 max-w-md mx-auto relative overflow-hidden">
                <div className="text-center mb-6">
                    <img
                        className='w-36 mx-auto mb-4'
                        src="/assets/img/team/Login-profile 3 .png"
                        alt="Admin Login"
                    />
                    <h4 className='text-2xl font-bold text-gray-800 tracking-wide'>Admin Login</h4>
                    <p className='text-gray-500 text-sm mt-1'>Enter your credentials to access admin panel</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="relative group">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1 hidden">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-200 bg-gray-50 hover:bg-white"
                            placeholder='Email Address'
                            name='email'
                            onChange={handleChange}
                            value={LoginData.email}
                            disabled={submitting}
                            autoComplete="email"
                        />
                        {Error.email && <p className='text-red-500 text-xs mt-1 ml-1'>{Error.email}</p>}
                    </div>

                    <div className="relative group">
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1 hidden">Password</label>
                        <div className="relative">
                            <input
                                type={passwordshow}
                                id="password"
                                placeholder='Password'
                                className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-200 bg-gray-50 hover:bg-white pr-10"
                                name='password'
                                onChange={handleChange}
                                value={LoginData.password}
                                disabled={submitting}
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-primary transition-colors cursor-pointer p-1"
                                onClick={!submitting ? handlepasswordshowornot : undefined}
                                disabled={submitting}
                            >
                                {passwordshow === "password" ? <FaRegEyeSlash size={18} /> : <FaRegEye size={18} />}
                            </button>
                        </div>
                        {Error.password && <p className='text-red-500 text-xs mt-1 ml-1'>{Error.password}</p>}
                    </div>

                    {/* Remember Me Checkbox */}
                    <div className="flex items-center pl-1">
                        <label className="flex items-center space-x-2 cursor-pointer group">
                            <input
                                id="remember-me-check"
                                type="checkbox"
                                checked={rememberMe}
                                onChange={handleRememberMeChange}
                                className="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary/40 cursor-pointer transition-all"
                            />
                            <span className="text-gray-600 text-sm group-hover:text-primary transition-colors select-none">Remember Me</span>
                        </label>
                    </div>

                    <button
                        type="submit"
                        className="w-full py-3 px-4 bg-primary hover:bg-primary-600 text-white font-semibold rounded-full shadow-md hover:shadow-lg transform active:scale-95 transition-all duration-200 flex justify-center items-center"
                        disabled={submitting}
                    >
                        {submitting ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Logging in...
                            </>
                        ) : (
                            "Login"
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;